import Navigation from "@/components/Navigation";

const HairRestoration = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-24 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-serif mb-8">Hair Restoration</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <img
                src="/lovable-uploads/57b53a43-b8f1-43f8-ba01-417c651840b0.png"
                alt="Hair Restoration"
                className="w-full h-[400px] object-cover rounded-lg shadow-lg"
              />
              <div className="grid grid-cols-2 gap-4 mt-4">
                <img
                  src="/lovable-uploads/d7f85bb6-371d-4220-a8de-731b82af2520.png"
                  alt="Treatment 1"
                  className="w-full h-48 object-cover rounded-lg shadow-lg"
                />
                <img
                  src="/lovable-uploads/3de191f3-3c4b-4412-90d4-87631be581b1.png"
                  alt="Treatment 2"
                  className="w-full h-48 object-cover rounded-lg shadow-lg"
                />
              </div>
            </div>
            <div>
              <p className="text-lg mb-6">
                Restore your confidence with our advanced hair restoration treatments. We offer cutting-edge solutions for hair loss using the latest technology and proven techniques.
              </p>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-2">PRP Therapy</h3>
                  <p>Stimulate natural hair growth with Platelet-Rich Plasma therapy.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Hair Growth Treatment</h3>
                  <p>Customized treatments to promote healthy hair growth and prevent further loss.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Red Light Laser Therapy</h3>
                  <p>Advanced treatment using low-level laser therapy to stimulate natural hair growth and improve follicle health.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Hair Loss Prevention</h3>
                  <p>Comprehensive programs to prevent and manage hair loss.</p>
                </div>
              </div>
              <a
                href="https://na02.patientnow.com/a/EVOLVEDYOU"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors mt-8"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HairRestoration;